import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PaymentMethodData } from 'shared/types';
import { PaymentMethod } from '../RecurlyAccountInformation/PaymentMethod';

type RecurlySavedPaymentProps = {
  paymentMethod: PaymentMethodData;
};

export const RecurlySavedPayment = (
  props: RecurlySavedPaymentProps,
): JSX.Element => {
  const { paymentMethod } = props;
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      {paymentMethod.paymentType === 'paypal_billing_agreement' && (
        <PaymentMethod type="PayPal" />
      )}

      {paymentMethod.paymentType === 'apple_pay' && (
        <PaymentMethod type="ApplePay" />
      )}

      {paymentMethod.paymentType === 'credit_card' && (
        <>
          {paymentMethod.cardType && (
            <PaymentMethod type={paymentMethod.cardType} />
          )}

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="body1">
              {t('recurlySavedPayment.paymentMethod.cardNumber', {
                number: paymentMethod.lastFour,
              })}
            </Typography>

            <Typography variant="body2" color="secondary">
              {t('recurlySavedPayment.paymentMethod.cardExpires', {
                month: paymentMethod.expMonth,
                year: paymentMethod.expYear.toString().substring(2),
              })}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};
